import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const ProductTopSection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleTabClick = (tabName) => {
        // Handle tab navigation
        navigate(`/${tabName}`);
    };


    return (
        <>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-image hero-background">
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <div className="hero-yellow-line"></div>
                            <h1 className="hero-title">상조의전</h1>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sub Navigation */}
            <section className="sub-navigation">
                <div className="tab-container">
                    <a
                        className={`tab-link ${location.pathname.includes('mutual-assistance-product-info')
                             || location.pathname.includes('service-advantages')
                             || location.pathname.includes('event-procedure')
                             ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('mutual-assistance-product-info');
                        }}
                    >
                        상품안내
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('opening-relocation') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('opening-relocation');
                        }}
                    >
                        개장/이장
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('general-funeral-procedures')
                            || location.pathname.includes('funeral-information-religious')
                            || location.pathname.includes('funeral-methods')
                            || location.pathname.includes('funeral-information-other')
                            ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('general-funeral-procedures');
                        }}
                    >
                        장례정보
                    </a>
                </div>
            </section>

        </>
    )
}

export default ProductTopSection;